import React, { useState, FC } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useAuth } from '../../auth/core/Auth';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ProfileDetails } from '../../accounts/components/settings/cards/ProfileDetails';

const API_URL_REAL = process.env.REACT_APP_API_URL

export const UploadId: FC = () => {
    const intl = useIntl();
    const { logout } = useAuth();



    return (
        <div>
            <ProfileDetails />

        </div>
    );
};
